import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, ClockIcon } from 'lucide-react';
import { Countdown } from '../Countdown';
import { PriceCard } from '../PriceCard';
import { pricing } from '../../data/landing';
export function Offer() {
  return <section id="oferta" className="scroll-mt-4 bg-brand-soft px-5 py-16 md:py-24" data-id="element-180" data-mp="356celppngkvl">
      <div className="mx-auto max-w-3xl" data-id="element-181" data-mp="3549f8f2lxfe7">
        <div className="rounded-[2rem] bg-white p-7 text-center shadow-sm md:p-10" data-id="element-182" data-mp="3a68jdr668gc7">
          <p className="flex items-center justify-center gap-2 text-sm font-black uppercase tracking-[0.15em] text-danger md:text-base" data-id="element-183" data-mp="3f4a2gc3lkfno">
            <ClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-184" data-mp="3jwjld86aofgg" />
            Precio de lanzamiento — cierra en:
          </p>
          <div className="mt-6" data-id="element-185" data-mp="3nyy65xtixpad">
            <Countdown data-id="element-186" data-mp="3sw6rg79yy9fu" />
          </div>
          <p className="mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-gold-soft px-4 py-2 text-base font-semibold text-charcoal" data-id="element-187" data-mp="3sx9do1wcjnpf">
            <AlertTriangleIcon className="h-5 w-5 shrink-0 text-gold-strong" aria-hidden="true" data-id="element-188" data-mp="1klgikc3ixyg6" />
            Después sube {pricing.increase}. No vuelve más.
          </p>

          <div className="mt-8 text-left" data-id="element-189" data-mp="1fohsq5qw8dns">
            <div className="flex items-center justify-between gap-3 text-sm font-bold" data-id="element-190" data-mp="1bka2g44sepng">
              <span className="flex items-center gap-2 text-charcoal" data-id="element-191" data-mp="16lysltehsf58">
                <span className="relative flex h-2.5 w-2.5" data-id="element-192" data-mp="16o1sd55g5mn5">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-danger opacity-75 motion-reduce:animate-none" data-id="element-193" data-mp="23aob9lxy1bs9" />
                  <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-danger" data-id="element-194" data-mp="1ujo0ax5n0kj8" />
                </span>
                Cupos al precio de lanzamiento
              </span>
              <span className="text-danger" data-id="element-195" data-mp="1pigrcurrdfaz">Quedan pocos</span>
            </div>
            <div className="mt-3 h-3 overflow-hidden rounded-full bg-line" role="progressbar" aria-valuenow={pricing.claimedPercent} aria-valuemin={0} aria-valuemax={100} data-id="element-196" data-mp="2n1i5om3p5zq1">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: `${pricing.claimedPercent}%`
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              ease: [0.23, 1, 0.32, 1]
            }} className="h-full rounded-full bg-danger" data-id="element-197" data-mp="3653jajkwz64y" />
            </div>
            <p className="mt-2 text-sm text-muted" data-id="element-198" data-mp="2idemor127vi7">
              {pricing.claimedPercent}% de los cupos al precio de lanzamiento ya tomados
            </p>
          </div>
        </div>

        <h2 className="mt-16 text-center text-3xl font-black uppercase tracking-tight text-brand md:text-5xl" data-id="element-199" data-mp="29fmfyb9elw6f">
          Elegí tu MegaPack
        </h2>
        <div className="mt-10" data-id="element-200" data-mp="7my8tqtn2old">
          <PriceCard subtitle="5 Tomos + 5 Bonos + Plan Maestro (30 días)" idealFor="Quienes quieren curación de 7 a 30 días completa" ctaLabel="Quiero el MegaPack ahora" data-id="element-201" data-mp="7moexs5h3xae" />
        </div>
      </div>
    </section>;
}